export const EMPTY_INGEST_UPLOAD_META = {
  companyName: '',
  subfolderPath: '',
  description: '',
} as const;

export type IngestUploadLineStatus = 'pending' | 'uploading' | 'completed' | 'error';

export interface IngestUploadLineLike {
  status: IngestUploadLineStatus | string;
}

/** Tras un lote OK se limpian metadatos; si hubo fallos se conservan para reintento (#0000034). */
export function shouldResetIngestUploadMetaAfterBatch(lines: IngestUploadLineLike[]): boolean {
  if (lines.length === 0) {
    return false;
  }
  return lines.every((line) => line.status === 'completed');
}
